import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { signOut } from "../../actions/auth";
import { createNotification } from "../notifications/notifications";

export default function AccessRoute({ children, ...rest }) {
  const dispatch = useDispatch();
  const someValue1 = useSelector(
    (state) => state.auth.access_modes?.["Режимы"]?.["Показатели деятельности вуза"]
  );
  // const someValue = useSelector(
  //   (state) => state.auth.access_modes?.["Отчётность"]?.["Постоянный состав"]
  // );
  return (
    <Route
      {...rest}
      render={() =>
        someValue1 == "Полный"  ? (
          children
        ) : (
          (() => {
            createNotification('error', 'Доступ закрыт');
            return <Redirect to="/" />;
          })()
        )
      }
    />
  );
}
